import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

// Single-select event for event manager invite: one event only, dropdown closes after selection
export default class extends Controller {
  static targets = ["eventOption", "selectedList", "hiddenInputsContainer", "dropdownToggle"]
  // The picker is shared by the invite and the edit-member modals, which post
  // under different param scopes, so the hidden-input name comes from the view.
  static values = { paramName: { type: String, default: "team_invitation[event_slugs][]" } }

  toggleEvent(event) {
    event.preventDefault()
    event.stopPropagation()
    const option = event.currentTarget
    const slug = option.dataset.slug
    if (!slug) return

    const existing = this.selectedListTarget.querySelector(`[data-selected-slug="${slug}"]`)
    if (existing) {
      this.removeBySlug(slug)
      option.classList.remove("selected")
      option.querySelector(".selected-event-check")?.classList.add("d-none")
      this.closeDropdown()
    } else {
      // this.clearAllSelected()
      this.addSelected(slug, option)
      option.classList.add("selected")
      const check = option.querySelector(".selected-event-check")
      if (check) check.classList.remove("d-none")
      this.closeDropdown()
    }
  }

  closeDropdown() {
    if (!this.hasDropdownToggleTarget) return
    const instance = bootstrap.Dropdown.getInstance(this.dropdownToggleTarget)
    if (instance) instance.hide()
  }

  clearAllSelected() {
    this.selectedListTarget.querySelectorAll("[data-selected-slug]").forEach(row => row.remove())
    this.hiddenInputsContainerTarget.querySelectorAll("input[data-slug]").forEach(input => input.remove())
    this.eventOptionTargets.forEach(opt => {
      opt.classList.remove("selected")
      opt.querySelector(".selected-event-check")?.classList.add("d-none")
    })
  }

  remove(event) {
    event.preventDefault()
    event.stopPropagation()
    const row = event.currentTarget.closest("[data-selected-slug]")
    if (!row) return
    const slug = row.dataset.selectedSlug
    this.removeBySlug(slug)
    const option = this.eventOptionTargets.find(el => el.dataset.slug === slug)
    if (option) {
      option.classList.remove("selected")
      option.querySelector(".selected-event-check")?.classList.add("d-none")
    }
  }

  addSelected(slug, optionElement) {
    const clone = optionElement.querySelector(".event-card-clone-source")?.cloneNode(true)
    if (!clone) return

    const wrapper = document.createElement("div")
    wrapper.className = "event-item"
    wrapper.setAttribute("data-selected-slug", slug)
    const cardWrap = document.createElement("div")
    cardWrap.className = "event-card flex-grow-1"


    const removeBtn = document.createElement("button")
    removeBtn.type = "button"
    removeBtn.className = "btn cancel-btn p-0 mr-10 flex-shrink-0 align-self-center"
    removeBtn.setAttribute("data-action", "click->invite-event-select#remove")
    removeBtn.setAttribute("aria-label", "Remove")
    removeBtn.innerHTML = "×"
    removeBtn.style.fontSize = "1.25rem"
    removeBtn.style.lineHeight = 1
    cardWrap.appendChild(removeBtn)
    cardWrap.appendChild(clone)
    wrapper.appendChild(cardWrap)

    this.selectedListTarget.appendChild(wrapper)

    const input = document.createElement("input")
    input.type = "hidden"
    input.name = this.paramNameValue
    input.value = slug
    input.dataset.slug = slug
    this.hiddenInputsContainerTarget.appendChild(input)
  }

  removeBySlug(slug) {
    const row = this.selectedListTarget.querySelector(`[data-selected-slug="${slug}"]`)
    if (row) row.remove()
    const input = this.hiddenInputsContainerTarget.querySelector(`input[data-slug="${slug}"]`)
    if (input) input.remove()
  }
}
